import { useState, useEffect } from "react"
import { NavLink, useLocation } from "react-router-dom"
import { RiMenu3Fill } from "react-icons/ri"
import { IoMdClose } from "react-icons/io"

const links = [
  { name: "home", link: "/" },
  { name: "about", link: "/about" },
  { name: "projects", link: "/projects" },
  { name: "contact", link: "/contact" },
]

const Navbar = () => {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if (open) setOpen(false)
  }, [location])

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10)
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return (
    <nav
      className={`sticky top-0 z-50 px-6 py-5 my-[15px] backdrop-blur-3xl transition-all duration-300 ${
        scrolled
          ? "bg-[#1a171bea] shadow-[0_4px_30px_rgba(0,0,0,0.4)]"
          : "bg-[#1a171bc4]"
      }`}
    >
      <div className="max-w-[1240px] mx-auto flex justify-between items-center">
        <NavLink to="/" className="text-2xl font-bold tracking-wide">
          mashady
        </NavLink>

        <button
          className="text-3xl md:hidden cursor-pointer p-1"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <IoMdClose /> : <RiMenu3Fill />}
        </button>

        {/* desktop menu */}
        <ul className="hidden md:flex items-center gap-10">
          {links.map((link) => (
            <li key={link.name} className="text-[17px] capitalize">
              <NavLink
                to={link.link}
                className={({ isActive }) =>
                  `relative pb-1 transition-colors duration-200 hover:text-[#6b69f2] ${
                    isActive
                      ? "text-[#6b69f2] after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-[#6b69f2] after:rounded-full"
                      : "text-[#f5f1f9]"
                  }`
                }
              >
                {link.name}
              </NavLink>
            </li>
          ))}
          <li>
            <a
              href="https://drive.google.com/file/d/1nO-g4-l2WIpfKvWSzVmc37-yww0jNmze/view?usp=drive_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="btn">Resume</button>
            </a>
          </li>
        </ul>

        {/* mobile menu */}
        <ul
          className={`md:hidden absolute top-full left-0 w-full main-bg px-6 pb-6 flex flex-col gap-4 transition-all duration-300 ease-in-out overflow-hidden ${
            open ? "max-h-[400px] opacity-100 pt-4" : "max-h-0 opacity-0 pt-0"
          }`}
        >
          {links.map((link) => (
            <li key={link.name} className="text-[18px] capitalize border-b border-[#2e2a31] pb-3 last:border-0">
              <NavLink
                to={link.link}
                className={({ isActive }) =>
                  `transition-colors duration-200 ${
                    isActive ? "text-[#6b69f2] font-semibold" : "hover:text-[#6b69f2]"
                  }`
                }
              >
                {link.name}
              </NavLink>
            </li>
          ))}
          <li className="pt-1">
            <a
              href="https://drive.google.com/file/d/1nO-g4-l2WIpfKvWSzVmc37-yww0jNmze/view?usp=drive_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="btn w-full">Resume</button>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Navbar
